import { bffCrmPersonCareGaps } from '@fireflyhealth/api'
import type { BffCrmPersonCareGapsRetrieveResponse } from '@fireflyhealth/api'

import { useQuery } from '~/shared/hooks/query'
export type PersonCareGap = BffCrmPersonCareGapsRetrieveResponse['care_gaps'][number]

/**
 * Fetches a member's care gaps from the CRM BFF
 * (`GET /bff/crm/person/<person_id>/care-gaps/`). Rows arrive already scoped to active
 * measures, gap-status-derived, and ordered open-gaps-first; the client only renders them.
 * Disabled until a `personId` is available.
 */
export const useGetPersonCareGaps = (variables: { personId: number | undefined }) => {
  const { personId } = variables
  return useQuery<BffCrmPersonCareGapsRetrieveResponse>(
    personId != null
      ? bffCrmPersonCareGaps.retrieveQueryKey({ person_id: personId })
      : ['retrieveBffCrmPersonCareGaps', {}],
    async () => (await bffCrmPersonCareGaps.retrieve({ person_id: Number(personId) })).data,
    { enabled: personId != null },
    { error: 'Failed to fetch care gaps' },
  )
}
